import { render, staticRenderFns } from "./ReadymadeGarments.vue?vue&type=template&id=168e9732&"
import script from "./ReadymadeGarments.vue?vue&type=script&lang=js&"
export * from "./ReadymadeGarments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports